console.log('map');

// ライフインフォマップ初期位置
function centerScroll(map) {
    const img = map.querySelector("img");
    if (!img) return;

    // 横・縦のスクロールを中央へ
    // map.scrollLeft = (img.scrollWidth - map.clientWidth) / 2;
    map.scrollLeft = (img.scrollWidth - map.clientWidth) * .2;
}

// ページ読み込み時に全ての map_img を中央へ
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".mapImg").forEach(map => {
        const img = map.querySelector("img");
        if (!img) return;

        img.addEventListener("load", () => centerScroll(map));
        if (img.complete) centerScroll(map); // 既に読み込まれている場合
    });
});

const swipe = document.querySelectorAll('.mapBox');

swipe.forEach((swipe) => {
    swipe.addEventListener('touchstart', function () {
        swipe.classList.add('hide');
    })
})
